import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import {observer} from 'mobx-react'
import PageSubHeader from '../../components/common/page_sub_header'
import ItemFaq from '../../components/item/item_faq'
import ReactPaginate from 'react-paginate'
import {PAGECOUNT} from '../../config/const'
import {rootStore} from '../../mobx/store'

const Faq = observer(() => {
  const context = useContext(Page_settings)
  let [faqList, setFaqList] = useState([])
  let [pageCount, setPageCount] = useState(0)
  let [page, setPage] = useState(1)
  let [empty, setEmpty] = useState(false)


  useEffect(() => {
    getFaq(page)
  }, [page])

  const getFaq = (page) => {
    context.post('cs/qa_list', {page: page, count: PAGECOUNT},
      response => {
        setFaqList(response.list)
        setPageCount(response.page_count)
        setEmpty(response.page_count == 0)
        if (rootStore.isSignedIn) {
          let mb = rootStore.getMe
          mb.mb_point = response.mb_point
          rootStore.signIn(mb)
        }
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const handlePageClick = (component) => {
    setPage(component.selected + 1)
  }

  return (
    <React.Fragment>
        <div className={'mt-30'}>
          <PageSubHeader pageName={strings.faq} pageMenu1={strings.main} pageMenu2={strings.cs_center} pageMenu={strings.faq}/>
          <div className='term-content-area bd-b-0 bg-white p-0 mb-40'>
            {
              faqList.map((info, idx) => {
                return (
                  <ItemFaq key={idx} info={info} toggle={() => {setFaqList(prev => prev.map((it, index) => {it.open = index === idx ? !it.open : it.open; return it;}))}}/>
                )
              })
            }
            {empty && <div className='d-center color-3a3335 fs-16 f-b empty_label hx-100'>{strings.empty_faq}</div>}
          </div>
          {pageCount > 1 &&
          <ReactPaginate
            previousLabel={''}
            nextLabel={''}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
          />
          }
        </div>
    </React.Fragment>
  )
})

export default withRouter(Faq)
